const keyStoreTypes = {
  GET_ALL_KEYSTORES_SUCCESS: 'GET_ALL_KEYSTORES_SUCCESS',
  GET_ALL_KEYSTORES_FAILURE: 'GET_ALL_KEYSTORES_FAILURE',
};

export default keyStoreTypes;
